// Alias
import DefaultHeader from '../../header';

export default DefaultHeader;



// WEBPACK FOOTER //
// ./components/lookup/menu/default-footer/index.jsx